import React, { useState, useEffect, useRef, useContext } from "react";
import { useHistory } from "react-router-dom";
import Breadcrumb from "./Breadcrumb";
import { Modal } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { notify, notifyWarning } from "../Toastmessage/Toastmessage";
import { AdminService } from "../../../services/admin-service";
import { DataGrid } from "@material-ui/data-grid";
import TablePagination from "@material-ui/core/TablePagination";
import moment from "moment";
import { PermissionService } from "../../../services/permission-service";
import AuthContext from "../../../context/auth-context";

export const Content = (props) => {
  const ctx = useContext(AuthContext);
  const format2 = "YYYY-MM-DD";
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const [count, setDataCount] = useState(0);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const formRef = useRef();

  const [submitloading, setSubmitLoading] = useState(true);

  const [state, setState] = useState(false);

  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

  const [admins, setAdmin] = useState([]);

  const history = useHistory();

  const [adminID, setadminID] = useState();

  const handleShow4 = (e) => {
    setState({ show4: true });
    setadminID(e);
  };

  const handleShow3 = (e) => {
    setState({ show3: true });
  };

  const handleClose = (e) => {
    setState({ show3: false });
  };

  const onSubmitForm = async (
    values,
    { resetForm, setErrors, setStatus, setSubmitting, setFieldValue }
  ) => {
    //todo extra validations
    setSubmitLoading(false);

    try {
      await AdminService.adminCreate(
        values.name,
        values.address,
        values.phone,
        values.nic,
        values.role,
        values.access_level,
        values.email,
        values.password
      );
      formRef.current.resetForm();

      setSubmitLoading(true);
      notify("System user successfully added");
      handleClose();
      adminSearch();
    } catch (err) {
      setSubmitLoading(true);

      //show error toast
      if (err.response.data.message !== undefined) {
        notifyWarning(err.response.data.message);
        // notifyWarning(err.response.data.message[0]);
      } else {
        notifyWarning("Something Wrong");
      }
    }
  };

  const adminSearch = async () => {
    try {
      const result = await AdminService.adminDetails(rowsPerPage, page);

      setAdmin(result);
      setDataCount(result.length);
    } catch (err) {
      //toast
      if (err.response.data.message !== undefined) {
        notifyWarning(err.response.data.message);
      } else {
        notifyWarning("Something Wrong");
      }
    }
  };

  const onDelete = async () => {
    //todo extra validations
    setSubmitLoading(false);
    try {
      await AdminService.adminDelete(adminID);

      setSubmitLoading(true);
      notify("Admin successfully deleted");
      handleClose();
      adminSearch();
    } catch (err) {
      setSubmitLoading(true);
      //show error toast
      if (err.response.data.message !== undefined) {
        notifyWarning(err.response.data.message);
      } else {
        notifyWarning("Something Wrong");
      }
    }
  };

  useEffect(() => {
    adminSearch();
  }, [rowsPerPage, page, count]);

  const [acclevel, setAccessLevel] = useState([]);

  const accessLevelSearch = async () => {
    try {
      const result = await PermissionService.accesslevelDetails();
      setAccessLevel(result);
    } catch (err) {
      //toast
    }
  };

  const columns = [
    {
      field: "id",
      headerName: "ID",
      flex: 1,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    },
    {
      field: "name",
      headerName: "Name",
      flex: 5,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    },
    {
      field: "role",
      headerName: "Role",
      flex: 5,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        // return acclevel.filter(
        //   (element) => (element.id === +params.row.role)[0]?.access_level
        // );

        return (
          <div>
            {/* {console.log(
              acclevel.find((element) => element.id == params.row.role)
            )} */}

            {
              acclevel.find((element) => element.access_level == params.row.role)
                ?.access_level
            }

            {/* {acclevel.find((element) => element.id == params.row.role)} */}
          </div>
        );
      },
    },
    {
      field: "email",
      headerName: "Email",
      flex: 5,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    },
    {
      field: "created_at",
      headerName: "Created Date",
      sortable: false,
      flex: 4,
      disableClickEventBubbling: true,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        return <div>{moment(params.row.created_at).format(format2)}</div>;
      },
    },
    {
      field: "edit",
      headerName: "Edit",
      sortable: false,
      flex: 1,
      disableClickEventBubbling: true,
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        return (
          <div
            onClick={() => {
              history.push(`/user-edit/${params.row.id}`);
            }}
            style={{ cursor: "pointer" }}
          >
            <i className="fas fa-pencil-alt text-secondary" />
          </div>
        );
      },
    },
    {
      field: "delete",
      headerName: "Delete",
      sortable: false,
      flex: 1,
      disableClickEventBubbling: true,
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        return (
          <div>
            <i
              className="far fa-trash-alt ms-text-danger"
              onClick={() => {
                handleShow4(params.row.id);
              }}
              style={{ cursor: "pointer" }}
            />
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    accessLevelSearch();
  }, []);

  return (
    <div className="ms-content-wrapper">
      <div>
        <ToastContainer />
      </div>
      <div className="row">
        <div className="col-md-12">
          <Breadcrumb />

          <div className="row">
            <div className="col-xl-12">
              <div className="ms-panel">
                <div className="ms-panel-header">
                  <div className="row">
                    <div className="col-md-11">
                      <h6>System User List</h6>
                    </div>
                    <div>
                      <Modal
                        show={state.show4}
                        onHide={handleClose}
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                      >
                        <Modal.Header>
                          <h3 className="modal-title has-icon ms-icon-round ">
                            Confirm Deletion
                          </h3>
                          <button
                            type="button"
                            className="close"
                            onClick={handleClose}
                          >
                            <span aria-hidden="true">×</span>
                          </button>
                        </Modal.Header>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            marginTop: "2vh",
                          }}
                        >
                          <h6 style={{ color: "red" }}>
                            Are you sure you want to remove this item ?
                          </h6>
                        </div>
                        <Modal.Footer>
                          <div className="col-md-2" hidden={submitloading}>
                            <div className="spinner spinner-7">
                              <div className="bounce1" />
                              <div className="bounce2" />
                              <div className="bounce3" />
                            </div>
                          </div>
                          <button
                            type="button"
                            className="btn btn-primary shadow-none"
                            style={{ backgroundColor: "red" }}
                            onClick={onDelete}
                          >
                            Delete
                          </button>

                          <button
                            type="button"
                            className="btn btn-light"
                            onClick={handleClose}
                          >
                            Cancel
                          </button>
                        </Modal.Footer>
                      </Modal>
                    </div>
                    <div className="col-md-1">
                      {" "}
                      <div className="col-md-2 col-sm-4">
                        <button
                          type="button"
                          className="ms-btn-icon btn-primary"
                          name="button"
                          onClick={handleShow3}
                        >
                          <i className="material-icons">person_add</i>{" "}
                        </button>
                      </div>
                      <Modal
                        show={state.show3}
                        onHide={handleClose}
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                      >
                        <Modal.Header>
                          <h3 className="modal-title has-icon ms-icon-round ">
                            <i className="flaticon-share bg-primary text-white" />{" "}
                            New System User
                          </h3>
                          <button
                            type="button"
                            className="close"
                            onClick={handleClose}
                          >
                            <span aria-hidden="true">×</span>
                          </button>
                        </Modal.Header>
                        <Formik
                          initialValues={{
                            name: "",
                            address: "",
                            phone: "",
                            nic: "",
                            role: "",
                            access_level: "",
                            email: "",
                            password: "",
                          }}
                          validationSchema={Yup.object().shape({
                            name: Yup.string().required("Required"),

                            address: Yup.string().required("Required"),

                            phone: Yup.string()
                              .required("Required")
                              .matches(
                                phoneRegExp,
                                "Phone number is not valid"
                              ),

                            nic: Yup.string()
                              .required("Required")
                              .min(
                                10,
                                "nic number must have at  10 characters"
                              ),

                            role: Yup.string().required("Required"),

                            email: Yup.string().email().required("Required"),
                            access_level: Yup.string().required("Required"),
                            password: Yup.string()
                              .required("Required")
                              .min(
                                5,
                                "password must have at least 5 characters"
                              )
                              .max(
                                10,
                                "password must have less than 15 characters"
                              ),
                          })}
                          onSubmit={onSubmitForm}
                          innerRef={formRef}
                        >
                          {({
                            errors,
                            handleBlur,
                            handleChange,
                            touched,
                            values,
                            submitForm,
                            isValid,
                          }) => (
                            <div>
                              <Modal.Body style={{ maxHeight: "450px", overflowY: "auto" }}y>
                                <div className="mb-3">
                                  <label htmlFor="validationCustom08">
                                    Name
                                  </label>
                                  <div className="input-group">
                                    <input
                                      name="name"
                                      type="text"
                                      className="form-control"
                                      id="nameid"
                                      placeholder="Name"
                                      required
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.name}
                                    />
                                  </div>
                                  <div
                                    style={{ color: "red", fontSize: "12px" }}
                                  >
                                    {touched.name && errors.name}
                                  </div>
                                </div>
                                <div className="mb-3">
                                  <label htmlFor="validationCustom08">
                                    Address
                                  </label>
                                  <div className="input-group">
                                    <input
                                      name="address"
                                      type="text"
                                      className="form-control"
                                      id="addressid"
                                      placeholder="Address"
                                      required
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.address}
                                    />
                                  </div>
                                  <div
                                    style={{ color: "red", fontSize: "12px" }}
                                  >
                                    {touched.address && errors.address}
                                  </div>
                                </div>
                                <div className="mb-3">
                                  <label htmlFor="validationCustom08">
                                    Phone
                                  </label>
                                  <div className="input-group">
                                    <input
                                      name="phone"
                                      type="text"
                                      className="form-control"
                                      id="phoneid"
                                      placeholder="Phone Number"
                                      required
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.phone}
                                    />
                                  </div>
                                  <div
                                    style={{ color: "red", fontSize: "12px" }}
                                  >
                                    {touched.phone && errors.phone}
                                  </div>
                                </div>
                                <div className="mb-3">
                                  <label htmlFor="validationCustom08">
                                    Nic
                                  </label>
                                  <div className="input-group">
                                    <input
                                      name="nic"
                                      type="text"
                                      className="form-control"
                                      id="nicid"
                                      placeholder="NIC"
                                      required
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.nic}
                                    />
                                  </div>
                                  <div
                                    style={{ color: "red", fontSize: "12px" }}
                                  >
                                    {touched.nic && errors.nic}
                                  </div>
                                </div>
                                <div className="mb-2">
                                  <label htmlFor="validationCustom09">
                                    Role
                                  </label>
                                  <div className="input-group">
                                    <div className="input-group">
                                      <select
                                        name="role"
                                        className="form-control"
                                        id="selectrole"
                                        required
                                        value={values.role}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                      >
                                        <option value="">Select</option>

                                        {acclevel.map((item) => (
                                          <option value={item.access_level}>
                                            {item.access_level}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                    {/* <input
                                      name="role"
                                      type="text"
                                      className="form-control"
                                      id="roleid"
                                      placeholder="Role"
                                      required
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.role}
                                    /> */}
                                  </div>
                                  <div
                                    style={{ color: "red", fontSize: "12px" }}
                                  >
                                    {touched.role && errors.role}
                                  </div>
                                </div>
                                <div className="mb-2">
                                  <label htmlFor="validationCustom15">
                                    Access Level
                                  </label>
                                  <div className="input-group">
                                    <select
                                      name="access_level"
                                      className="form-control"
                                      id="selectstatus"
                                      required
                                      value={values.access_level}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    >
                                      <option value="">Select</option>

                                      {acclevel.map((item) => (
                                        <option value={item.id}>
                                          {item.access_level}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                  <div
                                    style={{ color: "red", fontSize: "12px" }}
                                  >
                                    {touched.access_level &&
                                      errors.access_level}
                                  </div>
                                </div>
                                <div className="mb-2">
                                  <label htmlFor="validationCustom09">
                                    Email
                                  </label>
                                  <div className="input-group">
                                    <input
                                      name="email"
                                      type="email"
                                      className="form-control"
                                      id="emailid"
                                      placeholder="Email"
                                      required
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.email}
                                    />
                                  </div>
                                  <div
                                    style={{ color: "red", fontSize: "12px" }}
                                  >
                                    {touched.email && errors.email}
                                  </div>
                                </div>
                                <div className="mb-2">
                                  <label htmlFor="validationCustom09">
                                    Password
                                  </label>
                                  <div className="input-group">
                                    <input
                                      name="password"
                                      type="password"
                                      className="form-control"
                                      id="passwordid"
                                      placeholder="Password"
                                      required
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.password}
                                    />
                                  </div>
                                  <div
                                    style={{ color: "red", fontSize: "12px" }}
                                  >
                                    {touched.password && errors.password}
                                  </div>
                                </div>

                                <div
                                  className="col-md-2"
                                  hidden={submitloading}
                                >
                                  <div className="spinner spinner-7">
                                    <div className="bounce1" />
                                    <div className="bounce2" />
                                    <div className="bounce3" />
                                  </div>
                                </div>
                              </Modal.Body>

                              <Modal.Footer>
                                <button
                                  type="button"
                                  className="btn btn-light"
                                  onClick={handleClose}
                                >
                                  Cancel
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-primary shadow-none"
                                  onClick={submitForm}
                                >
                                  Add
                                </button>
                              </Modal.Footer>
                            </div>
                          )}
                        </Formik>
                      </Modal>
                    </div>
                  </div>
                </div>
                <div className="ms-panel-body">
                  <div style={{ flex: "100%"}}>
                    <DataGrid
                      rows={admins}
                      disableExtendRowFullWidth={false}
                      columns={columns}
                      pageSize={rowsPerPage}
                      pagination
                      autoHeight
                      hideFooter
                    />
                    <TablePagination
                      component="div"
                      count={count}
                      page={page}
                      onPageChange={handleChangePage}
                      rowsPerPage={rowsPerPage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Content;
